export var RootError;
(function (RootError) {
    RootError[RootError["NONE"] = 0] = "NONE";
    RootError[RootError["NOT_FOUND"] = 1] = "NOT_FOUND";
    RootError[RootError["UNKNOWN"] = 2] = "UNKNOWN";
})(RootError || (RootError = {}));
